const DefaultDate = {
  defaultStartDate: "2022-02-02",
  defaultEndDate: "2022-02-10",
};

export default DefaultDate;
